<template>
	<script type="text/x-template" id="template-midtoneTexture" class="template">
		<li class="block edit_block midtoneTexture-block adjustment-block">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">Texture</label>
		    </div>

		    <div class="block_options">
		        <div class="block-sliders-container">
		            <span class="slider-name">Texture</span>
		            <input type="range" min="0" max="5" value="0" step="0.1" data-pass-index="0" class="range_slider midtone-texture_slider adjustmentBlock-slider">
					<div class="input-group --with-knob">
						<input type="text" class="input-knob" />
						<input type="number" class="range_value midtone-texture_range adjustmentBlock-range" value="0" name="quantity" min="0" max="5" step="0.1">
					</div>
		        </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
